import { pupillometryInstruction } from "@constants/instructionConstants";
import { virtualAssistancePupillometryConfig } from "@constants/virtualAssistanceConstants";
import {
  PupillometryCustomConfiguration,
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  WaitDuration,
  TestUIConfiguration,
} from "types/testTypes";
import { CATEGORY_VERSION_MAP, TEST_TYPE_VERSION_MAP } from "../versionConstants";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
} from "../configurationHelperConstants";

export const pupillometryCustomConfig: PupillometryCustomConfiguration = {
  lapCount: 1,
  initialWaitDuration: 2.0,
  stimulusShowDuration: 0.5,
  recoveryDuration: 8.0,
};

export const rapdCustomConfig: PupillometryCustomConfiguration = {
  lapCount: 8,
  initialWaitDuration: 2.0,
  stimulusShowDuration: 0.1,
  recoveryDuration: 1.0,
};
export const availablePupillometryTestConfigurationOptions: AvailablePreTestConfigurationOptions = {
  testTypes: {
    configurationFieldName: "testType",
    choices: [
      {
        validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.Pupillometry],
        value: TestType.Pupillometry,
      },
      { validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.RAPD], value: TestType.RAPD },
    ],
    isMandatory: true,
    validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.Pupillometry],
  },
  eyeConfigurationOptions: { ...AVAILABLE_EYE_OPTIONS_BINOCULAR },
  languageOptions: null,
  virtualAssistantOptions: {
    ...AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
  },
  testSpeedOptions: null,
};

export const pupillometryTestConfiguration: TestConfiguration = {
  name: TestCategory.Pupillometry,
  testType: TestType.Pupillometry,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: false,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: true,
    isBackToBackEyeTest: false,
  },
  testSpeed: WaitDuration.Standard,
  testLanguage: null,
  virtualAssistanceConfig: virtualAssistancePupillometryConfig,
  isPressToStartEnabled: true,
};

export const pupillometryUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: pupillometryInstruction,
};
